<template>
    <div>
        <!-- <input type="file" :name="name" :class="{'error': error, 'success': success}" :disabled="disabled" :value="value" @keyup.enter="$emit('enter')" @input="$emit('input',$event.target.value)" class="form-control" :placeholder="placeholder"> -->
        <label class="custom-file">
          <input :disabled="disabled" type="file" id="file" class="custom-file-input" @change="sendAmazon($event.target.files[0])">
          <span class="custom-file-control">{{placeholder}}</span>
        </label>
    </div>
</template>

<script>
// var fs = require('browserify-fs')
export default {
  props: {
    placeholder: String,
    // type: String,
    value: {
      type: [Number, String],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    async sendAmazon (logo) {
      const formData = new FormData()
      formData.append('file', logo)
      const response = await fetch('https://upload.keepneye.com/upload', {
        method: 'POST',
        'Content-Type': 'application/json',
        body: formData
      })
      if (response && response.status === 200) {
        const resp = await response.json()
        if (resp.data && resp.data.URL) {
          this.$emit('input', resp.data.URL)
        } else {
          console.log('UPLOAD ERROR (' + logo.name + ')')
        }
      } else {
        console.log('UPLOAD ERROR (' + logo.name + ')')
      }
    }
  }
}
</script>

<style scoped>
.error{
  border-color: red !important;
}
.success{
  border-color: #58d858 !important;
}
</style>
